<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item, index) in waitFeedbackEnquiryTabs"
          :key="index"
        >
          <el-form class="search-style">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-form-item v-if="activeName === '待处理任务'">
                  <Select
                    :options="JSON.stringify(waitFeedbackEnquiryList)"
                    @change="changgeAttribute"
                    :value="params.column"
                  ></Select>
                </el-form-item>
                <el-form-item v-if="activeName === '我的待处理'">
                  <Select
                    :options="JSON.stringify(waitFeedbackEnquiryListWait)"
                    @change="changgeAttribute"
                    :value="params.column"
                  ></Select>
                </el-form-item>
                <el-form-item v-if="activeName === '我的已处理'">
                  <Select
                    :options="JSON.stringify(waitFeedbackEnquiryListMy)"
                    @change="changgeAttribute"
                    :value="params.column"
                  ></Select>
                </el-form-item>
              </el-col>

              <el-col :span="4" v-show="params.column === 'ocNeednumber'">
                <el-form-item>
                  <Select
                    :options="JSON.stringify(expressionList)"
                    @change="changgeExpression"
                    :value="params.expression"
                  ></Select>
                </el-form-item>
              </el-col>

              <el-col :span="6" v-if="params.column === 'isOnline'">
                <el-form-item>
                  <el-select v-model="params.value">
                    <el-option label="上线" :value="2"></el-option>
                    <el-option label="临时" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="params.column === 'ocExtype'">
                <el-form-item>
                  <el-select v-model="params.value">
                    <el-option label="期货" value="期货"></el-option>
                    <el-option label="现货" value="现货"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item>
                  <el-input
                    v-show="
                      params.column !== 'createDate' &&
                        params.column !== 'isOnline' &&
                        params.column !== 'processDate' &&
                        params.column !== 'updateDate' &&
                        params.column !== 'ocExtype'
                    "
                    v-model="params.value"
                    placeholder="请输入关键词"
                  ></el-input>
                  <el-date-picker
                    v-model="time"
                    style="width:100%;"
                    type="datetimerange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    :default-time="['00:00:00', '23:59:59']"
                    v-show="
                      params.column === 'createDate' ||
                        params.column === 'processDate' ||
                        params.column === 'updateDate'
                    "
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item>
                  <el-button @click="onSearch" type="primary">搜索</el-button>
                  <el-button @click="ResetSearch" type>重置</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="params.column === 'ocNeednumber' ? 6 : 10" style="text-align:right;">
                <el-form-item>
                  <el-button @click="onBatch" v-show="activeName === '待处理任务'" type="primary">批量认领</el-button>
                  <el-checkbox
                    style="padding-left:20px;"
                    v-model="checked"
                    v-show="activeName === '待处理任务'"
                  >每60秒刷新当前页面</el-checkbox>
                  <div v-show="activeName === '我的待处理'">
                    <el-button @click="outToLead">批量导出</el-button>
                    <el-button @click="onToLead">批量导入</el-button>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div class="box-table" :style="{height: tableHeight+'px'}">
            <el-table
              border
              ref="goodsDetailTable"
              style="width: 100%"
              :data="list"
              :max-height="tableHeight"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                fixed
                type="selection"
                :key="1"
                width="35"
                :selectable="selectableFun"
                v-if="activeName==='待处理任务'"
              ></el-table-column>
              <el-table-column prop="inquiryNumber" show-overflow-tooltip label="询价单编号" min-width="120px"></el-table-column>
              <el-table-column prop="pcName" show-overflow-tooltip label="品类" min-width="120px"></el-table-column>
              <el-table-column prop="brandName" show-overflow-tooltip label="品牌" min-width="120px"></el-table-column>
              <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
              <el-table-column show-overflow-tooltip prop="proName" label="产品名称" min-width="120px"></el-table-column>
              <el-table-column prop="proType" show-overflow-tooltip min-width="120px" label="型号"></el-table-column>
              <el-table-column
                prop="orderNumber"
                show-overflow-tooltip
                min-width="120px"
                label="订货号"
              >
                <template slot-scope="scope">
                  {{
                  scope.row.orderNumber || "--"
                  }}
                </template>
              </el-table-column>
              <!-- <el-table-column prop="ocExtype" label="类型"></el-table-column> -->
              <el-table-column prop="ocExtime" label="货期">
                <template slot-scope="scope">
                  {{
                  scope.row.ocExtime +"天"
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="ocNeednumber" label="数量"></el-table-column>
              <el-table-column label="产品状态">
                <template slot-scope="scope">
                  {{
                  scope.row.isOnline === 1 ? "临时" : "上线"
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="createUser" label="提交人"></el-table-column>
              <el-table-column label="提交时间" min-width="150">
                <template slot-scope="scope">
                  <span v-show="scope.row.createDate === null">{{ "--" }}</span>
                  <span v-show="scope.row.createDate !== null">
                    {{
                    scope.row.createDate | dateFilter
                    }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="staffCnName" label="认领人" v-if="activeName === '待处理任务'">
                <template slot-scope="scope">
                  {{
                  scope.row.staffCnName ||'--'
                  }}
                </template>
              </el-table-column>
              <el-table-column
                min-width="125"
                prop="processDate"
                label="认领时间"
                v-if="activeName !== '我的已处理'"
              >
                <template slot-scope="scope">
                  {{
                  scope.row.processDate | dateFilter
                  }}
                </template>
              </el-table-column>
              <el-table-column
                label="处理时间"
                v-if="activeName === '我的已处理'"
                :key="Math.random()"
                min-width="125"
              >
                <template slot-scope="scope">
                  {{
                  scope.row.updateDate | dateFilter
                  }}
                </template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" min-width="120">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    @click="onClaim(scope.row)"
                    :key="Math.random()"
                    v-if="
                      activeName === '待处理任务' && scope.row.ownId === null
                    "
                  >认领</el-button>
                  <el-button
                    type="text"
                    @click="onExtract(scope.row)"
                    :key="Math.random()"
                    v-if="activeName === '待处理任务' && scope.row.staffCnName!== null && scope.row.staffCnName !== localStorage&&scope.row.stockPower===2"
                  >提取</el-button>
                  <el-button
                    type="text"
                    :key="Math.random()"
                    v-if="activeName === '待处理任务' && scope.row.staffCnName !== null && scope.row.staffCnName === localStorage||activeName === '我的待处理'"
                    @click="onHandle(scope.row)"
                  >处理</el-button>
                  <span
                    class="approval"
                    @click="onSee(scope.row)"
                    v-if="activeName === '我的已处理'"
                    :key="activeName"
                  >查看</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination">
            <pagination
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            ></pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-------------- 批量导入 -------------->
    <lead-in @onRefresh="onRefresh" ref="leadInRefs"></lead-in>
    <open-or-close
      @onUpdataState="onUpdataState"
      content="确认是否批量认领？"
      title="提示"
      ref="openOrCloseRefs"
    ></open-or-close>
  </div>
</template>
<script>
import OpenOrClose from '@/components/OpenOrClose/index'
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
import { getAuth } from '@/util/auth'
import Select from '@/components/tableColumn/selectTable'
import { deepClone } from '@/util'
import {
  waitFeedbackEnquiryTabs,
  waitFeedbackEnquiryList,
  waitFeedbackEnquiryListMy,
  waitFeedbackEnquiryListWait
} from './util/data'
import leadIn from '@/components/leadIn/index'
import {
  queryAllOrderManuallnquiry,
  updateByMiState,
  updateByMiStateExtract,
  orderEnquiryCoeDerive
} from '@/api/purchase/purchaseManage'

import { formatDate, resetTableLayout, downLoadFileBlob } from '@/util/tool'
export default {
  components: {
    pagination: pagination,
    'lead-in': leadIn,
    Select,
    'open-or-close': OpenOrClose
  },
  data() {
    return {
      localStorage: '',
      timer: null, // 定时器名称,
      activeName: '待处理任务', // tabs选中状态
      waitFeedbackEnquiryTabs: waitFeedbackEnquiryTabs, // tabs状态
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      params: {
        endValue: ''
      },
      paramsList: {},
      waitFeedbackEnquiryList: waitFeedbackEnquiryList, // 筛选条件
      waitFeedbackEnquiryListMy: waitFeedbackEnquiryListMy, // 筛选条件
      waitFeedbackEnquiryListWait: waitFeedbackEnquiryListWait, // 筛选条件
      expressionList: expressionList,
      checked: false,
      miState: 0, // 列表状态
      time: [],
      tableHeight: window.innerHeight - 380,
      checkList: []
    }
  },
  mounted() {
    this.localStorageData()
    this.getList()
  },
  watch: {
    checked: {
      handler(newVal) {
        if (newVal === true) {
          this.timer = setInterval(() => {
            this.getList()
          }, 60000)
        } else {
          clearInterval(this.timer)
        }
      }
    }
  },
  methods: {
    selectableFun(row) {
      if (this.activeName === '待处理任务' && row.ownId === null) {
        return true
      }
    },

    handleSelectionChange(val) {
      this.checkList = val
    },
    onBatch() {
      if (this.checkList.length < 1) {
        this.$message.error('请选择一条或者多条')
      } else {
        this.title = '认领确定'
        this.content = '确定认领待反馈询价申请？'
        this.$refs.openOrCloseRefs.onInitial()
      }
    },
    onUpdataState() {
      const arr = []
      this.checkList.forEach(ele => {
        arr.push(ele.omiId)
      })
      updateByMiState(1, arr)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('已认领!')
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 认领
    onClaim(row) {
      const arr = []
      const arr1 = [row]
      arr1.forEach(ele => {
        arr.push(ele.omiId)
      })
      updateByMiState(1, arr)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('已认领!')
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    changgeAttribute(val, valObjList) {
      this.params.column = val
      delete this.params.value
      delete this.params.endValue
      this.time = []
    },
    changgeExpression(val) {
      this.params.expression = val
    },
    localStorageData() {
      this.localStorage = JSON.parse(getAuth()).usercnname
    },
    // 导出
    outToLead() {
      const params = {
        criteriaVoList: [this.paramsList],
        queryPageName: ''
      }
      const queryParams = {}
      queryParams.queryCriteriaVo = params
      queryParams.templateUrl = this.$store.state.purchaseGuidIn
      orderEnquiryCoeDerive(queryParams)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    onRefresh() {
      this.getList()
    },

    // tabs切换时触发的事件
    handleClick(tab) {
      this.params = {}
      this.paramsList = {}
      this.currentPage = 1
      this.activeName = tab.name
      this.getList()
      this.checked = false
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList() {
      this.loadingTable = true
      this.list = []
      if (this.activeName === '待处理任务') {
        this.miState = 0
      } else if (this.activeName === '我的待处理') {
        this.miState = 1
      } else if (this.activeName === '我的已处理') {
        this.miState = 2
      }
      const params = {
        criteriaVoList: [this.paramsList],
        queryPageName: ''
      }
      queryAllOrderManuallnquiry(this.miState, this.currentPage, this.pageSize, params)
        .then(res => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.list = res.data.obj.records
            this.total = res.data.obj.total
            resetTableLayout.call(this, this.$refs.goodsDetailTable)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 搜索
    onSearch() {
      this.paramsList = deepClone(this.params)
      if (this.time && this.time.length === 2) {
        this.paramsList.value = this.time[0]
        this.paramsList.endValue = this.time[1]
      }

      if (
        this.paramsList.value === '' ||
        this.paramsList.value === undefined ||
        this.paramsList.column === undefined
      ) {
        // this.getList()
        this.$message.error('搜索条件不能为空')
      } else {
        this.currentPage = 1
        this.pageSize = 30
        this.getList()
      }
    },
    ResetSearch() {
      this.time = []
      this.params = {}
      this.paramsList = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    // 处理
    onHandle(row) {
      this.$router.push({
        name: 'inquiryProductDetails',
        query: { omiId: row.omiId, isOnline: row.isOnline, proId: row.proId }
      })
    },

    // 提取
    onExtract(row) {
      updateByMiStateExtract(row.omiId, 2)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('已提取!')
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 操作询价状态
    getUpdateByMiState(row, type) {
      updateByMiState(row.omiId, type)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success(type === 1 ? '已认领!' : '已提取!')
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 查看
    onSee(val) {
      this.$router.push({
        name: 'inquiryResultDetails',
        query: { omiId: val.omiId }
      })
    },
    // 批量导入
    onToLead() {
      this.$refs.leadInRefs.onLeadIn(
        this.$store.state.purchaseGuidIn,
        '采购-待处理反馈询价导出导入'
      )
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val

      this.getList()
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter(time) {
  if (time === null) {
    return '--'
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>
<style lang="less" scoped>
.number-yet,
.number-wait,
.number-yetCreate {
  bottom: 14px;
  left: 122px;
}
.number-wait {
  left: 245px;
}
.number-yetCreate {
  left: 365px;
}
</style>
